export const stylesConfig = {
  mainLogo: `${process.env.REACT_APP_I18N_PATH}/logo/menu_top_logo.png?ddd2`,
};
